// @ts-nocheck
/**
 * Zebra-stripe — alternating row colors (the Dashboard pattern).
 *
 * Same colors defined in pages/dashboard/dashboardTableConfig.ts but
 * isolated here so they can be used in any table without importing from the dashboard.
 *
 * Usage:
 *   <StyledTableRow sx={getZebraRowSx(index)}>...</StyledTableRow>
 */

export const ZEBRA_EVEN = "rgb(0, 0, 0)";
export const ZEBRA_ODD = "rgb(1, 1, 51)";

export const getZebraRowSx = (index) => ({
  backgroundColor: `${index % 2 === 0 ? ZEBRA_EVEN : ZEBRA_ODD} !important`,
});
